import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, _mergeProps({
    modelValue: _ctx.tooltip,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tooltip) = $event)),
    location: _ctx.tooltipLocation as LocationType,
    "open-on-click": _ctx.tooltipOnClick,
    "open-on-focus": _ctx.tooltipOnFocus,
    "open-on-hover": _ctx.tooltipOnHover,
    offset: _ctx.tooltipOffset,
    disabled: !_ctx.tooltipText || !_ctx.showTooltip
  }, _ctx.$attrs), {
    activator: _withCtx(({ props }: { props: Record<string,any> }) => [
      _createElementVNode("div", _mergeProps(props, {
        id: _ctx.buttonID,
        onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTouchStart && _ctx.handleTouchStart(...args))),
        onTouchend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleTouchEnd && _ctx.handleTouchEnd(...args)))
      }), [
        _renderSlot(_ctx.$slots, "target")
      ], 16, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", null, _toDisplayString(_ctx.tooltipText), 1)
      ])
    ]),
    _: 3
  }, 16, ["modelValue", "location", "open-on-click", "open-on-focus", "open-on-hover", "offset", "disabled"]))
}